<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    center
    title="结算明细--引入应收费用"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <SiruiSearch
        ref="baseInfoFormRef"
        :query="query"
        :columns="formColumn"
        labelWidth="120px"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></SiruiSearch>
      <SiruiTable
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :showToolbar="false"
        :columns="tableColumnList"
        :checkbox-config="{ checkMethod: disabledCheckboxRow }"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <template v-else-if="item.field === 'businessCategory'">{{
              dictListMap?.businessCategory.find((item) => item.value == row['businessCategory'])
                ?.label
            }}</template>
            <template v-else-if="item.field === 'processStatus'">{{
              row['processStatus'] == 0 ? '未处理' : '已处理'
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确认引入</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { formFields, tableColumnList } from './index.js';
  import superviseContractAPI from '@/api/receivablesAndPayables/superviseContract.js';
  export default {
    name: 'IntroductionCostDialog',
    data() {
      return {
        tableColumnList,
        dialogVisible: false,
        loading: false,
        query: {
          contractNo: '',
          expenseType: '',
          periodDateFrom: '',
          periodDateUntil: '',
          processStatus: '0',
        },
        tableData: [],
        selectionList: [],
        lineDetailsList: [],
      };
    },
    methods: {
      disabledCheckboxRow({ row }) {
        let ids = this.lineDetailsList.map((item) => item.id);
        return !ids.includes(row.id);
      },
      openModal(data = {}, fetchTableData = []) {
        this.query = {
          ...this.query,
          ...data,
        };
        this.dialogVisible = true;
        // 默认选中的
        this.lineDetailsList = fetchTableData;
        this.$nextTick(() => {
          this.getTableData();
        });
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      confirmHandler() {
        if (this.selectionList.length) {
          this.$emit('confirmHandler', this.selectionList);
          this.cancelHandler();
        } else {
          this.$message.error('请选择行');
        }
      },
      handleSelectionChange(row) {
        console.log(row, 'row');
        this.selectionList = row;
      },
      // 获取表格数据
      async getTableData() {
        console.log('搜索');
        // this.tableData = this.mockDataList;
        this.loading = true;
        const postData = {
          ...this.query,
          businessCategory: '05',
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const { data } = await this.$axios.post(superviseContractAPI.GET_PAGE_TABLE, postData);
        console.log(data, '应收费用清单');
        this.loading = false;
        this.tableData = data.data?.records.map((item) => {
          return {
            ...item,
            settlementQuantity: item.statementQuantity,
          };
        });
        this.$refs.siruiTable.setPageTotal(data.data?.total);
      },
      // 搜索
      queryBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
    computed: {
      formColumn() {
        return formFields(this);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
